<template>
  <div id="app">
    <router-view />
    <plugin-com
      v-show="false"
      ref="de-theme"
      component-name="ThemeSetting"
    />
    <!-- <el-dialog
      v-if="$route.path !== '/login'"
      :visible.sync="showPasswordModifiedDialog"
      append-to-body
      :title="$t('user.change_password')"
      :show-close="false"
    >
      <PasswordUpdateForm old-pwd="dataease" />
    </el-dialog> -->
  </div>
</template>

<script>
import PluginCom from '@/views/system/plugin/PluginCom'
import { mapState } from 'vuex'
// import PasswordUpdateForm from '@/views/system/user/PasswordUpdateForm.vue'
import Cookies from 'js-cookie'
export default {
  name: 'App',
  components: { PluginCom
  // PasswordUpdateForm
  },
  computed: {
    ...mapState('user', [
      'passwordModified'
    ])
  },
  data() {
    return {
      showPasswordModifiedDialog: false
    }
  },
  watch: {
    passwordModified: {
      handler(val) {
        this.showPasswordModifiedDialog = !val
      },
      immediate: true
    }
  },
  created() {
    // const herf = window.location.href // 取得整个地址栏
    // const index = herf.indexOf('?')
    // var theRequest = {}
    // if (index !== -1) {
    //   const str = herf.substr(index + 1)
    //   const strs = str.split('&')
    //   for (var i = 0; i < strs.length; i++) {
    //     theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
    //   }
    // }
    // console.log(theRequest)
    // const token = Cookies.get('zcy_data_ease_token') || undefined
    // const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyNzgyNTg2MzYsInVzZXJJZCI6MjUsInVzZXJuYW1lIjoiZGF0YWVhc2VaMjAwNTExQzE2NTcifQ.VHc_Z676rmFYsU1ATNWJnuvuMMKa4KSjgP9JRmXwncU'
    // if (token) {
    //   console.log('token', token)
    //   console.log(this.$route)
    //   this.$store.dispatch('user/login', { token: token }).then(() => {
    //     // this.$router.push({ path: '/panel/index' })
    //     console.log('成功')
    //   }).catch(() => {
    //     console.log('失败')
    //   })
    // }
  },
  mounted() {
    const passwordModified = JSON.parse(localStorage.getItem('passwordModified'))
    if (typeof passwordModified === 'boolean') {
      this.$store.commit('user/SET_PASSWORD_MODIFIED', passwordModified)
    }
  }
}
</script>
